'use client'

import React, { FC, ReactElement } from 'react'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import isFungible from '@/utils/is-fungible'

const CollectionDetailTabs: FC<{
	slug: string
	value: string
	onValueChange: (v: string) => void
}> = (props): ReactElement => {
	const { value, onValueChange, slug } = props
	return (
		<Tabs defaultValue="list" className="" value={value} onValueChange={onValueChange}>
			<TabsList className="w-full h-8 py-0.5 px-1 bg-transparent border rounded-[6px]">
				<TabsTrigger
					className="py-0.5 px-2 data-[state=active]:bg-accent rounded-[4px] text-xs"
					value="list"
				>
					List
				</TabsTrigger>
				<TabsTrigger
					className="py-0.5 px-2 data-[state=active]:bg-accent rounded-[4px] text-xs"
					value="delist"
				>
					Delist
				</TabsTrigger>
				{isFungible(slug) && (
					<TabsTrigger
						className="py-0.5 px-2 data-[state=active]:bg-accent rounded-[4px] text-xs"
						value="split"
					>
						Split
					</TabsTrigger>
				)}
				<TabsTrigger
					className="py-0.5 px-2 data-[state=active]:bg-accent rounded-[4px] text-xs"
					value="send"
				>
					Send
				</TabsTrigger>
				{!isFungible(slug) && slug === 'frozen' && (
					<TabsTrigger
						className="py-0.5 px-2 data-[state=active]:bg-accent rounded-[4px] text-xs"
						value="refund"
					>
						Unfreeze
					</TabsTrigger>
				)}
				{!isFungible(slug) && slug === 'frozen' && (
					<TabsTrigger
						className="py-0.5 px-2 data-[state=active]:bg-accent rounded-[4px] text-xs"
						value="consolidate"
					>
						Burn
					</TabsTrigger>
				)}
			</TabsList>
		</Tabs>
	)
}

export default CollectionDetailTabs
